import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearSession, tradeGet } from "../../utils/tradeApi";
import "./trade.css";

export default function TradeProjectSelect() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    tradeGet("/api/trade/projects")
      .then(setProjects)
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, []);

  function select(project) {
    localStorage.setItem("selectedTradeProject", JSON.stringify(project));
    navigate(`/trade/project/${project._id}`);
  }

  function logout() {
    clearSession();
    navigate("/trade", { replace: true });
  }

  return (
    <main className="trade-page trade-project-page">
      <header className="trade-simple-header">
        <img className="trade-logo" src="/images/gemterra-logo-20260112-t.png" alt="Gemterra" />
        <div>
          <span>{localStorage.getItem("userEmail")}</span>
          <button className="trade-link-button" onClick={logout}>Sign out</button>
        </div>
      </header>
      <section className="trade-project-wrap">
        <div className="trade-project-select-heading">
          <div><span className="trade-eyebrow trade-green">TRADE PORTAL</span><h1>Select a project</h1><p className="trade-muted">Choose a project to view its current drawing packages.</p></div>
          {localStorage.getItem("userRole") === "admin" && <button className="trade-button secondary" onClick={() => navigate("/trade/admin/projects")}>Manage Trade projects</button>}
        </div>
        {loading && <div className="trade-loading">Loading projects…</div>}
        {error && <div className="trade-alert error" role="alert">{error}</div>}
        {!loading && !error && projects.length === 0 && (
          <div className="trade-empty"><h3>No projects available</h3><p>Your account has not been assigned to a Trade project.</p></div>
        )}
        <div className="trade-project-grid">
          {projects.map((project, index) => (
            <button className="trade-project-card" key={project._id} onClick={() => select(project)}>
              <span className="trade-project-number">{String(index + 1).padStart(2, "0")}</span>
              <span><strong>{project.name}</strong><small>{project.description || "Current project drawings"}</small></span>
              <span className="trade-arrow">→</span>
            </button>
          ))}
        </div>
      </section>
    </main>
  );
}
